module.exports = __webpack_public_path__ + "img/8838ee6787bf24457a9856cab3644817.gif";